import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_house_hold" }, { title: "menu_sidebar_health_orders", link: "/house-hold/orders" }];

const HouseholdOrderListing = Loadable({
  loader: () => import("container/houseHold/order/listing"),
  loading() {
    return <Loader />;
  }
});

const HouseholdOrder = Loadable({
  loader: () => import("container/houseHold/order"),
  loading() {
    return <Loader />;
  }
});

export const HouseholdOrderRoutes: IRoute[] = [
  {
    path: "/house-hold/orders",
    element: <HouseholdOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/house-hold/orders/details/:id?",
    element: <HouseholdOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
